import invariant from 'tiny-invariant';
// Loads the Window.env global augmentation.
import type {} from '@dispatch/web/config';

// Use optional chaining on window.env so importing telemetry doesn't crash in
// environments where window.env is not injected (e.g. jsdom unit tests), the
// same pattern web/config uses.
const _AppInsightsConnectionString = window?.env?.APP_INSIGHTS || '';

// Fail fast on a real production misconfiguration (missing connection string)
// so a telemetry outage is loud, not silent. Gated to production so jsdom unit
// tests — where window.env is not injected — can still import this module.
if (process.env['NODE_ENV'] === 'production') {
  invariant(
    _AppInsightsConnectionString,
    'Missing App Insights Connection String, unable to configure telemetry'
  );
}

const TelemetryConfig = {
  AppInsightsConnectionString: _AppInsightsConnectionString,
};

export default TelemetryConfig;
